let audioContext = null;
let audioUnlocked = false;

function getAudioContext() {
  if (typeof window === "undefined") return null;

  const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextCtor) return null;

  if (!audioContext) {
    audioContext = new AudioContextCtor();
  }

  return audioContext;
}

/** Call on user click/tap before async face verification (silent — no beep). */
export function unlockAttendanceAudio() {
  if (typeof window === "undefined") return;

  audioUnlocked = true;

  try {
    const ctx = getAudioContext();
    if (ctx?.state === "suspended") {
      void ctx.resume();
    }
  } catch {
    // Ignore.
  }
}

function playWebAudioBeep() {
  const ctx = getAudioContext();
  if (!ctx) return;

  const start = () => {
    const now = ctx.currentTime;

    const playTone = (frequency, startAt, duration) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();

      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency, startAt);

      gain.gain.setValueAtTime(0.0001, startAt);
      gain.gain.exponentialRampToValueAtTime(0.35, startAt + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);

      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start(startAt);
      oscillator.stop(startAt + duration);
    };

    playTone(880, now, 0.12);
    playTone(1174.66, now + 0.13, 0.18);
  };

  if (ctx.state === "suspended") {
    void ctx.resume().then(start).catch(() => {});
    return;
  }

  start();
}

export function playAttendanceSuccessSound() {
  try {
    playWebAudioBeep();
  } catch {
    // Ignore audio failures.
  }
}

export function playAttendanceSuccessSoundIfEnabled(enabled) {
  if (enabled) {
    playAttendanceSuccessSound();
  }
}
